<div class="rounded-xl border border-amber-300 bg-amber-50 p-3.5 text-sm text-amber-900">
  <div class="flex items-start justify-between gap-2">
    <div class="flex items-start gap-2">
      <i class="fas fa-exclamation-triangle mt-0.5 text-amber-600"></i>
      <div>
        <p class="font-semibold">Reschedule or cancel these appointments first</p>
        <p class="mt-0.5 text-xs text-amber-800">{{ conflict.message }}</p>
      </div>
    </div>
    <button type="button" (click)="dismiss.emit()" class="p-1 text-amber-700 hover:text-amber-900" aria-label="Dismiss">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <ul class="mt-3 max-h-56 divide-y divide-amber-200 overflow-y-auto rounded-lg border border-amber-200 bg-white">
    <li *ngFor="let appointment of conflict.appointments" class="flex items-center justify-between gap-2 px-3 py-2">
      <div class="min-w-0">
        <p class="truncate font-medium text-gray-800">{{ appointment.customerName || 'Customer' }}</p>
        <p class="text-xs text-gray-500">
          {{ appointment.date | date: 'EEE, d MMM y' }}
          <span *ngIf="appointment.timeSlot"> · {{ appointment.timeSlot }}</span>
          <span *ngIf="appointment.status"> · {{ appointment.status }}</span>
        </p>
      </div>
      <a [routerLink]="['/appointments-list', appointment.id]" target="_blank"
        class="shrink-0 text-xs font-semibold text-blue-600 hover:text-blue-800">
        Open <i class="fas fa-external-link-alt ml-0.5"></i>
      </a>
    </li>
  </ul>

  <p *ngIf="hiddenCount > 0" class="mt-2 text-xs text-amber-800">
    and {{ hiddenCount }} more appointment(s).
  </p>
</div>
